import React, { useState, useEffect, useContext, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import pdficon from "./../Asset/PDF.png";
import csvicon from "./../Asset/CSV.png";
import axios from "axios";
import LiquidFillGauge from "react-liquid-gauge";
import { color } from "d3-color";
import { useSelector } from "react-redux";
import TabContext from "@mui/lab/TabContext";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { styled, useTheme } from "@mui/material/styles";
import moment from "moment";
import { DataGrid, GridToolbar, GridToolbarContainer, GridToolbarQuickFilter } from "@mui/x-data-grid";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Pagination from '@mui/material/Pagination';
import MSelect from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Button from "@mui/material/Button";
import { Breadcrumbs, Typography } from "@mui/material";
import GetAppIcon from '@mui/icons-material/GetApp';
import "./accessbilitydesign.css";
import { Commonfun } from './../Commonfun';
import { timezonechange } from './../Commonfun';
import { timezoneval } from './../Commonfun';
import Loader from "../CommonLoader";
import { AppContext } from "../../../Context/Context";
import CommonAlert from "../../../Commonalert/commonalert";
import ErrorCountsvg from "../Asset/esocardicon/SourceCodeAnalysis/ErrorCount.svg"
import FatalErrorCountsvg from "../Asset/esocardicon/SourceCodeAnalysis/FatalErrorCount.svg"
import WarningCountsvg from "../Asset/esocardicon/SourceCodeAnalysis/WarningCount.svg"
import Commoncard from "../Commoncard";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import DatagridComp from "../DatagridComp";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';



const AccessbilityaxeDetails = () => {

  let querystring = useParams();
  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
  const ItemId = querystring.id;
  const JobId = querystring.jobid;
  const esodata = useSelector((state) => state);
  let detailurl = `${process.env.REACT_APP_DOMAIN}accessibility-score-scan-detail/`;
  const [jobDate, SetjobDate] = useState("");
  const [queryurl, Setqueryurl] = useState("");
  const [loading, setLoading] = useState(false);
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page1, setPage1] = useState(1);
  const [rowsPerPage1, setRowsPerPage1] = useState(10);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloadingcsv, setIsDownloadingcsv] = useState(false);
  const [autoheightval, SetAutoheightval] = useState(true);
  const [tableLoading, setTableLoading] = useState(true);

  const navigate = useNavigate();
  const ApiToken = esodata.apiauthkey.value;


  const [value, setValue] = useState("1");

  const columns = [
    // {
    //   field: "nid",
    //   headerName: "#",
    //   minWidth: 80,
    //   flex: 1,
    //   disableClickEventBubbling: true,
    //   headerAlign: "center",
    //   align: "center",

    // }
    ,
    {
      field: "impact",
      headerName: "Impact",
      description: "The severity level of the accessibility issue.",
      minWidth: 200,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",

    },
    {
      field: "issue_name",
      headerName: "Issue Name",
      description: "The name of the identified issue.",
      minWidth: 250,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "issue_description",
      headerName: "Issue Description",
      description: "A brief explanation of the issue.",
      minWidth: 350,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "total_count",
      headerName: "Total Count ",
      description: "The total number of occurrences of identified issue.",
      minWidth: 150,
      flex: 1,

      headerAlign: "center",
      align: "center",
    },
    {
      field: "view",
      headerName: "View",
      description: '',
      minWidth: 150,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      headerClassName: 'hide_option',
      renderCell: (cardData) => {

        if (value == 1)
          var typedata = "passed";
        else if (value == 2)
          var typedata = "failed";

        return (
          <a href={detailurl + `${ItemId}` + "/" + `${cardData.row.id}` + "/" + `${typedata}` + "/" + `${JobId}`}>
            <button className="view-report-button">
              View Report
            </button>
          </a>
        );
      },
    }
  ];
  const columns1 = [
    // {
    //   field: "sid",
    //   headerName: "#",
    //   minWidth: 80,
    //   flex: 1,
    //   disableClickEventBubbling: true,
    //   headerAlign: "center",
    //   align: "center",

    // }
    ,
    {
      field: "impact",
      headerName: "Impact",
      description: "The severity level of the accessibility issue.",
      minWidth: 200,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",

    },
    {
      field: "issue_name",
      headerName: "Issue Name",
      description: "The name of the identified issue.",
      minWidth: 250,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "issue_description",
      headerName: "Issue Description",
      description: "A brief explanation of the issue.",
      minWidth: 350,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "total_count",
      headerName: "Total Count ",
      description: "The total number of occurrences of identified issue.",
      minWidth: 150,
      flex: 1,

      headerAlign: "center",
      align: "center",
    },
    {
      field: "view",
      headerName: "View",
      description: '',
      minWidth: 150,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      headerClassName: 'hide_option',
      renderCell: (cardData) => {

        if (value == 1)
          var typedata = "passed";
        else if (value == 2)
          var typedata = "failed";

        return (
          <a href={detailurl + `${ItemId}` + "/" + `${cardData.row.id}` + "/" + `${typedata}` + "/" + `${JobId}`}>
            <button className="view-report-button">
              View Report
            </button>
          </a>
        );
      },
    }
  ];


  const [ErrorCarddata, SetErrorCarddata] = useState([]);
  const [WarningsCarddata, SetWarningsCarddata] = useState([]);
  const [ErrorCardcount, SetErrorCardcount] = useState("");
  const [WarningCardcount, SetWarningCardcount] = useState("");


  const rows = ErrorCarddata ?? [];
  const rows1 = WarningsCarddata ?? [];


  const [searchQuery, setSearchQuery] = useState("");
  const searchInputRef = useRef(null);


  const filteredRows = Array.isArray(rows) ? rows.filter((row) => {
    return Object.values(row).some((value) =>
      value.toString().toLowerCase().includes(searchQuery.toLowerCase())
    );
  }) : [];


  const [searchQuery1, setSearchQuery1] = useState("");
  const searchInput1Ref = useRef(null);


  const filteredRows1 = Array.isArray(rows1) ? rows1.filter((row) => {
    return Object.values(row).some((value) =>
      value.toString().toLowerCase().includes(searchQuery1.toLowerCase())
    );
  }) : [];



  const AccessbilityScoreDetail = async () => {
    setTableLoading(true);
    const datavalue = await axios.get(

      `${process.env.REACT_APP_API_URL}technical/accessibility_score_detail/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${JobId}&id=${ItemId}&audit_type=passed`, {
      headers: {
        Authorization: `${ApiToken}`,
      },
    }
    ).catch((error) => {
      if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
        setapiOpen(true);
        setapierrorMsg(error?.response?.data?.error)
      }
      else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
        navigate('/errorpages')
      }
    });



    if (datavalue?.data) {
      const dataval = datavalue?.data?.access_data;
      const newData = dataval.map((obj, index) => {
        return { ...obj, sid: index + 1 };
      });

      console.log("newData", newData);

      // const dataval1 = datavalue?.data?.acc_data[0]?.warning_data;
      // const newData1 = dataval1.map((obj, index) => {
      //   return { ...obj, sid: index + 1 };
      // });

      // const dataval2 = datavalue?.data?.acc_data[0]?.notice_data;
      // const newData2 = dataval2.map((obj, index) => {
      //   return { ...obj, tid: index + 1 };
      // });
      SetAutoheightval(false)
      SetErrorCardcount(datavalue?.data?.passed_count)
      SetWarningCardcount(datavalue?.data?.failed_count)

      // SetWarningCardcount(newData1?.length)
      // SetNoticeCardcount(newData2?.length)
      SetErrorCarddata(newData)
      // SetWarningsCarddata(newData1)
      // SetNoticesCarddata(newData2)
      if (datavalue?.data?.job_date)
        SetjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY HH:mm"))
      else
        SetjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY"))
      Setqueryurl(datavalue?.data?.url)
    }
    setTableLoading(false);

  };


  const AccessbilityScoreDetail1 = async () => {
    setTableLoading(true);
    const datavalue = await axios.get(

      `${process.env.REACT_APP_API_URL}technical/accessibility_score_detail/?user_domain_id=${esodata.domaindata.value.header_selected}&id=${ItemId}&job_id=${JobId}&audit_type=failed`, {
      headers: {
        Authorization: `${ApiToken}`,
      },
    }
    ).catch((error) => {
      if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
        setapiOpen(true);
        setapierrorMsg(error?.response?.data?.error)
      }
      else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
        navigate('/errorpages')
      }
    });



    if (datavalue?.data) {
      const dataval1 = datavalue?.data?.access_data;
      const newData1 = dataval1.map((obj, index) => {
        return { ...obj, sid: index + 1 };
      });
      SetAutoheightval(false)
      SetErrorCardcount(datavalue?.data?.passed_count)
      SetWarningCardcount(datavalue?.data?.failed_count)
      SetWarningsCarddata(newData1)
      if (datavalue?.data?.job_date)
        SetjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY HH:mm"))
      else
        SetjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY"))
      Setqueryurl(datavalue?.data?.domain_url)
    }
    setTableLoading(false);

  };


  useEffect(() => {
    if (value == 1)
      AccessbilityScoreDetail();
    else if (value == 2)
      AccessbilityScoreDetail1();
  }, [value]);
  const pdfdown = async () => {
    setLoading(true);
    setIsDownloading(true);
    if (value == 1)
      var typedata = "passed";
    else if (value == 2)
      var typedata = "failed";
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}technical/accessibility_score_detail/?user_domain_id=${esodata.domaindata.value.header_selected}&id=${ItemId}&job_id=${JobId}&audit_type=${typedata}&formats=pdf&timezone=${timezoneval()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });
      if (response.ok) {
        const blob = await response.blob();

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun("AccessibilityDetail", "pdf", ApiToken, esodata.domaindata.value.header_selected);

        link.download = filedata;
        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        toast.error("No Data", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        console.error('Failed to fetch PDF:', response.status, response.statusText);
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloading(false);
  }
  const csvdown = async () => {
    setLoading(true);
    setIsDownloadingcsv(true);
    if (value == 1)
      var typedata = "passed";
    else if (value == 2)
      var typedata = "failed";

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}technical/accessibility_score_detail/?user_domain_id=${esodata.domaindata.value.header_selected}&id=${ItemId}&job_id=${JobId}&audit_type=${typedata}&formats=csv&timezone=${timezoneval()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });
      if (response.ok) {
        const blob = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun("AccessibilityDetail", "csv", ApiToken, esodata.domaindata.value.header_selected);

        link.download = filedata;
        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        toast.error("No Data", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        console.error('Failed to fetch PDF:', response.status, response.statusText);
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloadingcsv(false);
  }
  const apihandleClose = () => {
    setapiOpen(false);
  };

  const Card = ({ id, title, value, iconSrc, activeTab, onClick }) => {
    const isActive = activeTab === id;
    return (
      <div
        className={`common-card-wrapper-style cardactivecontainer ${isActive ? "active" : ""}`}
        data-id={id}
        onClick={onClick}
      >
        <div className={`common-card-icon-container ${isActive ? "active" : ""}`}>
          <div className={`common-card-icons ${isActive ? "active" : ""}`}>
            <img
              src={iconSrc}
              className={`common-card-icon-img ${isActive ? "active" : ""}`}
              alt={title}
            />
          </div>
        </div>
        <div className={`common-card-subtitle ${isActive ? "active" : ""} cardcontentactivecontainer`}>
          <span className="common-card-title">{title}</span>
          <span className="common-card-value">{value}</span>
        </div>
      </div>
    );
  };

  const SwitchActiveTableTab = (Id) => {
    setPage(1);
    setValue(Id);
    setTableLoading(true);
  }

  const cardDatas = [
    {
      id: '1',
      activeValue: value,
      title: "Applicable Guidelines Passed",
      values: ErrorCardcount,
      iconSrc: ErrorCountsvg,
      altText: "Total Clicks",
      iconColor: 1,
      bgColor: 1,
      route: '1',
      handleCardClick: SwitchActiveTableTab
    },
    {
      id: '2',
      activeValue: value,
      title: "Applicable Guidelines Failed",
      values: WarningCardcount,
      iconSrc: WarningCountsvg,
      altText: "Warnings",
      iconColor: 2,
      bgColor: 2,
      route: '2',
      handleCardClick: SwitchActiveTableTab
    },
  ];

  useEffect(() => {
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [searchQuery]);

  useEffect(() => {
    if (searchInput1Ref.current) {
      searchInput1Ref.current.focus();
    }
  }, [searchQuery1]);

  const [download, setDownload] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDownload(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleDownlodingCSV = () => {
    csvdown();
  }

  const handleDownlodingPDF = () => {
    pdfdown();
  }



  return (
    <div className={`over_all_container ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
      {loading === true ? <Loader /> : null}

      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={4}>
              <div>
                <h1 className="dashboard_header">
                  Accessibility Score Detail Report
                </h1>
              </div>
            </Grid>
            <Grid item xs={12} md={8}>
              <div className="top_breadcrumb_menu">
                <div className="exportpdf_outer">
                  <div className="breadcrumb-wrapper">
                    <CommonBreadCrumb breadcrumbValue={[
                      { title: 'Technical' },
                      { title: 'Accessibility Score', activeColor: true, link: '/accessibility-score' },
                      { title: 'Accessibility Score Detail Report', activeColor: true }
                    ]} />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-time">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={6}>
              <div className="time_zone">
                <span><a target="_blank" href={queryurl}>
                  <span style={{ display: 'inline-block' }} className="spanlink">
                    {queryurl}
                  </span>
                </a>
                </span><br></br>
                <span className="timezone-date">{timezonechange(jobDate)} </span><br />
                <span className="timezone-val">{timezoneval()}</span>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>

            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-card-container">
        <Box className="dashboard-box-card">
          <Grid container className="dashboard-card-grid">
            <Grid item xs={12} md={12}>
              <div className="common-card-container" style={{ justifyContent: 'center' }}>
                {cardDatas.map((item, index) => (
                  <Grid item xs={12} sm={6} md={3} key={index}>
                    <Commoncard item={item} />
                  </Grid>
                  // <Card
                  //   key={id}
                  //   id={id}
                  //   title={title}
                  //   value={values}
                  //   iconSrc={iconSrc}
                  //   activeTab={value}
                  //   onClick={() => SwitchActiveTableTab(id)}
                  // />
                ))}
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="grid_table_shodow">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="cnt_audit_outer_wrap">
                <div className="">
                  {value == '1' &&
                    <DatagridComp
                      columns={columns}
                      rows={rows}
                      autoheightval={autoheightval}
                      datagridval={2}
                      columnFreezeWidth={[0, 200]}
                      tableLoading={tableLoading}
                      handleDownlodingCSV={handleDownlodingCSV}
                      handleDownlodingPDF={handleDownlodingPDF}
                      customFilter={false}
                      DownloadShowFile={true}
                      DownloadShowPDF={1}
                      DownloadShowCSV={2}
                    />
                  }
                  {value == '2' &&
                    <DatagridComp
                      columns={columns1}
                      rows={rows1}
                      autoheightval={autoheightval}
                      datagridval={2}
                      columnFreezeWidth={[0, 200]}
                      tableLoading={tableLoading}
                      handleDownlodingCSV={handleDownlodingCSV}
                      handleDownlodingPDF={handleDownlodingPDF}
                      customFilter={false}
                      DownloadShowFile={true}
                      DownloadShowPDF={1}
                      DownloadShowCSV={2}
                    />
                  }
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="footer-container">
        <Box className="footer-box">
          <Grid container className="footer-grid">
            <Grid item xs={12} md={6}>
              <div className="footer-left">
                <p className="footer-text">
                  All Rights Reserved Copyright © 2025 |
                  <a href="https://www.egrovesys.com/" target="blank">
                    <span className="footer-brand">eGrove Systems</span>
                  </a>
                </p>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="footer-right">
                <p>{/* Add content if needed */}</p>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <div className="cnt_audit_outer_wrap">
        {/* <div className="top_breadcrumb_menu">
          <CommonBreadCrumb breadcrumbValue={[
            { title: 'Technical' },
            { title: 'Accessibility Score', activeColor: true, link: '/accessibility-score' },
            { title: 'Accessibility Score Detail Report', activeColor: true }
          ]} />
          <div className="exportpdf_outer">
            <>
              <button className="exportpdf" alt="csv icon" onClick={isDownloadingcsv ? null : csvdown} title="CSV Download"  ><GetAppIcon />CSV</button>
              <button className="exportpdf" alt="pdf icon" onClick={isDownloading ? null : pdfdown} title="PDF Download" ><GetAppIcon />PDF</button>
            </>
          </div>
        </div>
        <div className="cnt_hdr_top_wraps">
          <div className="cnt_hdr_top_lft_wrap">
            <div style={{ display: "flex" }}>
              <h2 className="heading_font" style={{ letterSpacing: "0.8px", fontWeight: 900, color: "#ff601f" }}>Accessibility Score Detail Report</h2>
            </div>
            <a target="_blank" href={queryurl} style={{ display: 'flex', flexDirection: 'column' }}>
              <span className="spanlink">
                &nbsp; {queryurl}
              </span>
            </a>
            <p style={{ fontSize: "14px", letterSpacing: "0.8px", color: "#ff601fc2" }}>as of {timezonechange(jobDate)}  <span style={{ fontWeight: 700 }}>  {timezoneval()} </span></p>
          </div>
        </div>

        <div className="common-card-container" style={{ justifyContent: 'center' }}>
          {cardDatas.map(({ id, title, values, iconSrc }) => (
            <Card
              key={id}
              id={id}
              title={title}
              value={values}
              iconSrc={iconSrc}
              activeTab={value}
              onClick={() => SwitchActiveTableTab(id)}
            />
          ))}
        </div>

        <div className="tabs_outer_wrap tabs_outer_wrap_tab_btm_rem">
          {value == '1' &&
            <DatagridComp
              columns={columns}
              rows={rows}
              autoheightval={autoheightval}
              datagridval={2}
              columnFreezeWidth={[0, 200]}
              tableLoading={tableLoading}
            />
          }
          {value == '2' &&
            <DatagridComp
              columns={columns1}
              rows={rows1}
              autoheightval={autoheightval}
              datagridval={2}
              columnFreezeWidth={[0, 200]}
              tableLoading={tableLoading}
            />
          }
        </div> */}
        <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />
        {!openCommonAlerts &&
          <CommonErrorAlert
            data={{
              apiopen: apiopen,
              apiErrorMsg: apierrorMsg,
              isIconStyled: false
            }}
            closeAlert={apihandleClose} />
        }
      </div>
    </div>
  );
};

export default AccessbilityaxeDetails;
